export default __webpack_public_path__ + "static/media/cabinet-image.5ad775e0.png";